import { FormControl, FormLabel, Radio, RadioGroup } from '@mui/joy';

import Tooltip from 'core/elements/Tooltip';

import { IProps as RadioGroupProps } from './RadioGroupInput';

interface IProps extends RadioGroupProps {
  onChange?: (event) => void;
}

const RadioGroupInputView = ({
  name,
  label,
  defaultValue,
  value,
  choices,
  required,
  onChange,
  disabled,
  orientation,
}: IProps) => {
  return (
    <FormControl>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <RadioGroup defaultValue={defaultValue} value={value} name={name} orientation={orientation}>
        {choices?.map((choice) => {
          const radio = (
            <Radio
              key={choice.value}
              value={choice.value}
              label={choice.label}
              onChange={onChange}
              disabled={disabled || choice.disabled}
            />
          );

          if (!choice.tooltip) {
            return radio;
          }

          return (
            <Tooltip key={choice.value} title={choice.tooltip}>
              {radio}
            </Tooltip>
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGroupInputView;
